@if (showSearch) {
    <div class="px-4 pb-4 border-bottom-1 surface-border gap-2 flex flex-column align-content-center">
        <span class="p-input-icon-left flex flex-1">
            <i class="pi pi-search"></i>
            <input
                type="text"
                pInputText
                class="w-full outline-none"
                [placeholder]="searchPlaceholder | translate: 'Search'"
                (keyup)="onSearch($event)"
            />
        </span>
    </div>
}

@if (showSelectAll && items.length) {
    <div
        class="px-4 flex align-content-center py-3 border-bottom-1"
        style="border-color: var(--alpha-background-surface-hover-color)"
        [ngClass]="{ 'surface-100': allSelected }"
    >
        <p-checkbox
            [binary]="true"
            [label]="'default-cm-select-all' | translate: 'Select All'"
            [ngModel]="allSelected"
            (ngModelChange)="onSelectAll($event)"
        ></p-checkbox>
    </div>
}

<div class="overflow-auto flex-1">
    @for (item of items; track $index) {
        <div
            class="px-4 flex align-items-center justify-content-between py-3 border-bottom-1"
            style="border-color: var(--alpha-background-surface-hover-color)"
            [ngClass]="{
                'surface-100': item[checkedKey],
                'opacity-50': isDisabled(item),
            }"
        >
            <div class="flex align-items-center flex-1 overflow-hidden min-w-0">
                <p-checkbox
                    [binary]="true"
                    [(ngModel)]="item[checkedKey]"
                    [disabled]="isDisabled(item)"
                    (onChange)="onToggle(item)"
                ></p-checkbox>
                <label
                    class="px-3 overflow-hidden text-overflow-ellipsis white-space-nowrap"
                    [pTooltip]="getTooltip(item)"
                    tooltipPosition="top"
                >
                    {{ item[labelKey] }}
                </label>
            </div>
            @if (badgeKey) {
                <span
                    class="flex align-items-center justify-content-center bg-primary-700 radius-4xl width-40 height-20 flex-shrink-0 ml-2"
                >
                    <span class="text-sm font-medium text-gray-50">
                        {{ item[badgeKey] || 0 }}
                    </span>
                </span>
            }
        </div>
    }
</div>
@if (showMoreEnabled && !allLoaded) {
    <div class="flex justify-content-center py-3">
        <button
            type="button"
            class="cursor-pointer border-none bg-transparent text-primary-700 font-medium text-sm hover:underline"
            (click)="onShowMore()"
        >
            @if (loadingState) {
                <i class="pi pi-spin pi-spinner"></i>
            } @else {
                Show More
            }
        </button>
    </div>
}
